import React from 'react';
import { Sidebar } from '../../../components/Sidebar';
import { Header } from '../../../components/Header';
import { PlayCircleIcon, DownloadIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function VideoPreview() {
  const navigate = useNavigate();
  return <div className="flex w-full min-h-screen bg-gray-50" data-id="element-1643">
      <Sidebar data-id="element-1644" />
      <main className="flex-1" data-id="element-1645">
        <Header data-id="element-1646" />
        <div className="px-6 py-8" data-id="element-1647">
          <div className="max-w-4xl mx-auto" data-id="element-1648">
            <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-1649">
              Preview & Download
            </h1>
            <p className="text-gray-600 mb-6" data-id="element-1650">
              Review your video and download when ready
            </p>

            <div className="space-y-6" data-id="element-1651">
              <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1652">
                <h3 className="font-medium text-gray-800 mb-4" data-id="element-1653">
                  Video Preview
                </h3>
                <div className="flex justify-center" data-id="element-1654">
                  <div className="w-full max-w-md h-96 bg-gradient-to-br from-green-100 to-green-200 rounded-lg flex items-center justify-center border-2 border-gray-200 relative" data-id="element-1655">
                    <PlayCircleIcon className="text-gray-600" size={64} data-id="element-1656" />
                    <div className="absolute bottom-4 left-4 right-4 bg-black/50 backdrop-blur-sm rounded px-3 py-2 flex items-center justify-between" data-id="element-1657">
                      <div className="flex items-center space-x-2" data-id="element-1658">
                        <PlayCircleIcon className="text-white" size={20} data-id="element-1659" />
                        <div className="w-32 h-1 bg-gray-400 rounded-full" data-id="element-1660">
                          <div className="w-0 h-1 bg-white rounded-full" data-id="element-1661"></div>
                        </div>
                      </div>
                      <span className="text-white text-xs" data-id="element-1662">0:00 / 0:06</span>
                    </div>
                  </div>
                </div>
                <p className="text-sm text-gray-600 text-center mt-4" data-id="element-1663">
                  Click to play video preview
                </p>
              </div>

              <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1664">
                <h3 className="font-medium text-gray-800 mb-4" data-id="element-1665">
                  Video Information
                </h3>
                <div className="grid grid-cols-2 gap-4" data-id="element-1666">
                  <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-1667">
                    <p className="text-sm text-gray-600 mb-1" data-id="element-1668">
                      Animation Style
                    </p>
                    <p className="font-semibold text-gray-800" data-id="element-1669">Zoom In</p>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-1670">
                    <p className="text-sm text-gray-600 mb-1" data-id="element-1671">Duration</p>
                    <p className="font-semibold text-gray-800" data-id="element-1672">6 seconds</p>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-1673">
                    <p className="text-sm text-gray-600 mb-1" data-id="element-1674">Resolution</p>
                    <p className="font-semibold text-gray-800" data-id="element-1675">
                      1080 x 1080 px (1:1)
                    </p>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-1676">
                    <p className="text-sm text-gray-600 mb-1" data-id="element-1677">File Size</p>
                    <p className="font-semibold text-gray-800" data-id="element-1678">3.5 MB</p>
                  </div>
                </div>
              </div>

              <div className="bg-green-50 border border-green-200 rounded-lg p-4" data-id="element-1679">
                <h4 className="font-medium text-green-900 mb-2" data-id="element-1680">
                  Ready to Download
                </h4>
                <p className="text-sm text-green-800" data-id="element-1681">
                  Your video is optimized for social media platforms and ready
                  to use in your campaigns.
                </p>
              </div>

              <div className="flex justify-center space-x-4" data-id="element-1682">
                <button className="px-8 py-3 bg-blue-500 text-white rounded-md hover:bg-blue-600 font-medium transition-colors flex items-center" data-id="element-1683">
                  <DownloadIcon size={20} className="mr-2" data-id="element-1684" />
                  Download Video
                </button>
                <button onClick={() => navigate('/creative-customizer')} className="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-1685">
                  Create Another
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>;
}